module.exports = __webpack_public_path__ + "static/media/icon2.728b063c.svg";